import { useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { insert, without } from 'ramda'

import { Button } from '@/components/button-new'
import CloseButton from '@/components/close-button'
import { Label } from '@/components/text'
import useOnClickOutside from '@/components/use-onclick-outside'

import {
  ButtonsWrapper,
  FilterWrapper,
  InnerWrapper,
  TopWrapper
} from './elements'
import FurnishingSelector from './furnishing-selector'

const StyledFilterWrapper = styled(FilterWrapper)`
  width: 360px;
  margin-top: 8px;
  ${props => props.isExt && 'right: 0;'}
`

const FurnishingFilter = ({
  features = [],
  onChange,
  clickOutsideCallback,
  close,
  isExt
}) => {
  const { t } = useTranslation()
  const FurnishingFilterRef = useRef()
  useOnClickOutside(FurnishingFilterRef, e => clickOutsideCallback(e))
  const [values, setValues] = useState(features)

  const handleFeatureChange = e => {
    const id = e.target.id
    const checked = e.target.checked
    const filter = checked ? insert(0, id, values) : without([id], values)
    return setValues(filter)
  }

  return (
    <div ref={FurnishingFilterRef}>
      <StyledFilterWrapper isExt={isExt}>
        <InnerWrapper>
          <TopWrapper>
            <Label type="medium">
              {t(
                'filters:b.listing_filter.edit.furnishing.label',
                'Furnishing'
              )}
            </Label>
            <CloseButton
              onClick={close}
              height={12}
              width={12}
              top={20}
              right={16}
            />
          </TopWrapper>
          <FurnishingSelector onChange={handleFeatureChange} values={values} />
        </InnerWrapper>
        <ButtonsWrapper>
          <Button
            theme="text"
            size="small"
            onClick={() => {
              const withoutFurnishingFilters = values.filter(
                val => val !== 'furnished' && val !== 'unfurnished'
              )
              setValues(withoutFurnishingFilters)
            }}
          >
            {t('common.reset', 'Reset')}
          </Button>
          <Button
            theme="primary"
            size="small"
            onClick={() => onChange({ features: values })}
          >
            {t('common.save', 'Save')}
          </Button>
        </ButtonsWrapper>
      </StyledFilterWrapper>
    </div>
  )
}

export default FurnishingFilter
